// extracted by mini-css-extract-plugin
export default {"title":"styles_title__zIxpe","container":"styles_container__pXpRD"};